// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"10":"8cc27109","16":"b93142e5","300":"51234fff","453":"127be8e2","597":"320b07ef","652":"c4360307","890":"6d2309b7","975":"e9e5de03"}[chunkId] + ".chunk.js";
};